'use client';

import { useState, useEffect } from 'react';
import useSWR from 'swr';
import { useCartStore } from 'app/store/cart';
import { getPromoOrderGiveaway } from 'app/apis/promo';
import { CACHE_QUERY_KEY } from 'app/constants';

const potCartOrderGiveawayFetcher = async ([
    ,
    { product_total_price, promo_reduce_price, coupon_reduce_price },
]: [string, GetPromoOrderGiveawayParams]) =>
    getPromoOrderGiveaway({
        product_total_price,
        promo_reduce_price,
        coupon_reduce_price,
    });

export function useCartOrderGiveaway({
    product_total_price,
    promo_reduce_price,
    coupon_reduce_price,
    hasItems = false,
}: GetPromoOrderGiveawayParams & { hasItems: boolean }) {
    const {
        data: resp,
        isLoading,
        isValidating,
    } = useSWR(
        hasItems
            ? [
                  CACHE_QUERY_KEY.orderGiveaway,
                  { product_total_price, promo_reduce_price, coupon_reduce_price },
              ]
            : null,
        potCartOrderGiveawayFetcher
    );

    const [isCalculating, setCalculating] = useState(true);

    const { orderGiveaway, hasOrderGiveaway, updateCartOrderGiveaway } = useCartStore();

    useEffect(() => {
        if (!resp || !resp.data) {
            return;
        }

        const newOrderGiveaway = resp.data;

        updateCartOrderGiveaway(newOrderGiveaway);
    }, [resp, updateCartOrderGiveaway]);

    useEffect(() => {
        setCalculating(isValidating || isLoading);
    }, [isValidating, isLoading]);

    const state = {
        hasOrderGiveaway,
        orderGiveaway,
        isCalculating,
    };

    const actions = {
        setCalculating,
    };

    return {
        state,
        actions,
    };
}
